/** played: a content item's "Played" section (proof of play) in its information panel. Arabic is a draft for native review. */
const en = {
  "title": "Played",
  "last30": "Last 30 days",
  "loading": "Loading…",
  "failed": "Couldn't load playback.",
  "none": "Not played in the last 30 days.",
  "plays": "Plays",
  "time": "Time on screen",
  "buildings": "Buildings",
  "players": "Players",
  "chart": "Plays per day",
  "nPlays": "{n} play | {n} plays",
  "min": "{n} min",
  "hMin": "{h} h {m} min",
  "report": "Proof of play report",
};
const ar: typeof en = {
  "title": "العرض",
  "last30": "آخر 30 يومًا",
  "loading": "جارٍ التحميل…",
  "failed": "تعذّر تحميل بيانات العرض.",
  "none": "لم يُعرض خلال آخر 30 يومًا.",
  "plays": "مرات العرض",
  "time": "مدة الظهور",
  "buildings": "المباني",
  "players": "المشغّلات",
  "chart": "مرات العرض يوميًا",
  "nPlays": "لم يُعرض | مرة واحدة | مرتان | {n} مرات | {n} مرة | {n} مرة",
  "min": "{n} د",
  "hMin": "{h} س {m} د",
  "report": "تقرير إثبات العرض",
};
export default { en, ar };
